/* import __COLOCATED_TEMPLATE__ from './close-large.hbs.js'; */
import SvgIcon from '@square/glass-ui/components/svg/svg-icon';
export default class CloseLarge extends SvgIcon {}